import { Form } from '@fiverr-private/forms';

export default Form;
